import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Box } from '@mui/material'
import { GameVariantTabViews, RouletteLimitsTable, RpLimitsTable } from '../../components'
import { EGameVariant } from '../../constants/gameVariant'

const Limits: FC = observer(() => {
  const content = {
    [EGameVariant.ROULETTE]: <RouletteLimitsTable />,
    [EGameVariant.RUSSIAN_POKER]: <RpLimitsTable />,
  }

  return (
    <Box>
      <GameVariantTabViews tabContent={content} />
    </Box>
  )
})

export default Limits
